export default __webpack_public_path__ + "static/media/2.2277d9c8.jpg";